import * as Popover from '@radix-ui/react-popover';
import { Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Props {
  onSnooze: (until: string) => void;
}

function makeIso(daysOffset: number, hour: number, minute = 0): string {
  const d = new Date();
  d.setDate(d.getDate() + daysOffset);
  d.setHours(hour, minute, 0, 0);
  return d.toISOString();
}

export function SnoozePicker({ onSnooze }: Props) {
  const presets = [
    { label: 'Tra 1 ora', value: () => new Date(Date.now() + 3600_000).toISOString() },
    { label: 'Stasera (18:00)', value: () => makeIso(0, 18) },
    { label: 'Domani mattina', value: () => makeIso(1, 8) },
    { label: 'Lunedi` mattina', value: () => {
      const d = new Date();
      const offset = ((1 + 7 - d.getDay()) % 7) || 7;
      d.setDate(d.getDate() + offset);
      d.setHours(8, 0, 0, 0);
      return d.toISOString();
    }},
    { label: 'La settimana prossima', value: () => makeIso(7, 8) },
  ];

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5">
          <Clock className="h-4 w-4" /> Snooze
        </Button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content sideOffset={6} align="end" className="z-50 w-56 rounded-md border bg-popover shadow-md p-1">
          {presets.map((p) => (
            <button
              key={p.label}
              type="button"
              onClick={() => onSnooze(p.value())}
              className="w-full text-left px-2 py-1.5 rounded-sm text-sm hover:bg-accent"
            >
              {p.label}
            </button>
          ))}
          <div className="border-t mt-1 pt-1">
            <input
              type="datetime-local"
              onChange={(e) => {
                if (!e.target.value) return;
                onSnooze(new Date(e.target.value).toISOString());
              }}
              className="w-full px-2 py-1 text-xs bg-background border rounded"
            />
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
